module.exports = __webpack_public_path__ + "img/small-book.7c9c62b9.jpg";